@if (harAvstemninger()) {

  @if (brukerKanRedigere() && (harStemmeberettigede() || avstemningsstatus().appentForStemmegivning)) {
    <tittel-verdi tittel="{{ 'Status' | translate }}" stil="vertikal--med-linje" class="statuser" data-testid="status">
      <verdi>
        <div class="status-tittel">
          <div>{{ 'Avstemningene er'|translate }}</div>
          <div class="status-tittel-status">
            @if (avstemningsstatus().appentForStemmegivning) {
              {{ 'åpne for besvarelse'|translate }}
            } @else {
              {{ 'stengt for besvarelse'|translate }}
            }
          </div>
        </div>

        <c3-todelt-pai [andel]="antallStemmerAvgitt()"
                       [totalt]="produktAvStemmeberettigedeOgAvstemninger()"
                       [bredde]="60"
                       [konfig]="deltakereDonutKonfig()"
                       visningstype="donut"
                       [matTooltip]="stemmegivningDonutTooltip()">
          <div class="pai-tittel">
            <span class="pai-tittel-verdi">{{ antallStemmerAvgitt() / produktAvStemmeberettigedeOgAvstemninger()|percent }}</span>
            <span class="pai-subtittel">{{'besvart'|translate}}</span>
          </div>
        </c3-todelt-pai>

        <span class="handlinger">
          @if (avstemningsstatus().appentForStemmegivning) {
            <button mat-stroked-button color="primary" (click)="stengForAvstemning()" data-testid="steng-for-avstemning-knapp">
              {{ 'Steng for avstemning'|translate }}
            </button>

          } @else if (!avstemningsstatus().appentForStemmegivning) {
            <button mat-stroked-button color="primary" (click)="aapneForAvstemning()" data-testid="åpne-for-avstemning-knapp">
              {{ 'Åpne for avstemning'|translate }}
            </button>
          }
          <button mat-icon-button [matMenuTriggerFor]="avstemningerMeny" (click)="$event.stopPropagation()" class="meny-trigger" aria-label="Meny" data-testid="avstemninger-meny-knapp">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #avstemningerMeny="matMenu" aria-label="{{'Avstemninger-meny'|translate}}">
            @if (avstemningsstatus().appentForStemmegivning) {
              <button mat-menu-item (click)="stengForAvstemning()">
                <mat-icon>stop_circle</mat-icon>
                <span>{{ 'Steng for avstemning' | translate }}</span>
              </button>
            } @else if (!avstemningsstatus().appentForStemmegivning) {
              <button mat-menu-item (click)="aapneForAvstemning()">
                <mat-icon>play_circle</mat-icon>
                <span>{{ 'Åpne for avstemning' | translate }}</span>
              </button>
            }
            <button mat-menu-item (click)="redigerStemmeberettigede()">
              <mat-icon>edit</mat-icon>
              <span>{{ 'Rediger stemmeberettigede' | translate }}</span>
            </button>
            <mat-divider/>
            <button mat-menu-item (click)="nullstillAvgitteStemmerMedBekreftelsesdialog()">
              <mat-icon fontSet="ion-ios-trash" class="mat-icon--ionic-ikon"/>
              <span>{{ 'Nullstill stemmer' | translate }}</span>
            </button>
          </mat-menu>
        </span>
      </verdi>
    </tittel-verdi>
  }

  @if (!moete().tilgang.erMoetePublisert && brukerKanRedigere() && harAvstemninger()) {
    <tips>
      {{ 'Møtet er ikke publisert, møte må være publisert for at du skal kunne åpne for stemmegivning'|translate }}
    </tips>
  }

  @if (brukerKanRedigere() || harStemmeberettigede()) {
    <tittel-verdi tittel="{{ 'Stemmeberettigede' | translate }}" stil="vertikal--med-linje">
      <tittel>
        {{ 'Stemmeberettigede' | translate }}
        @if (brukerKanRedigere()) {
          <button mat-icon-button (click)="redigerStemmeberettigede()">
            <mat-icon>edit</mat-icon>
          </button>
        }
      </tittel>
      <verdi>
        <avstemning-stemmeberettigede [moete]="moete()"
                                      [moetedeltakere]="moetedeltakere()"
                                      [avstemningsstatus]="avstemningsstatus()"
                                      [brukerKanRedigere]="brukerKanRedigere()"
                                      [(erRedigermodus)]="viserRedigerStemmeberettigede"/>
      </verdi>
    </tittel-verdi>
  }

  <tittel-verdi stil="vertikal--med-linje" class="saker">
    <tittel>
      {{ 'Saker med avstemninger det skal stemmes over' | translate }}
      <tittel-handlinger-hoeyrestilt>
        <!-- @todo var e2e-visalle -->
        <mat-slide-toggle [checked]="visAlleSaker()" (change)="visAlleSaker.set(!visAlleSaker())" ngProjectAs="tittel-handlinger-hoeyrestilt">
          <!-- omsluttet av span for stiling -->
          <span>{{ 'Vis {antallSaker} saker uten avstemninger'|translate:{antallSaker: antallSakerUtenAvstemninger()} }}</span>
        </mat-slide-toggle>
      </tittel-handlinger-hoeyrestilt>
    </tittel>
    <verdi data-testid="møte-avstemninger">
      @for (innslag of sakerOgAvstemninger(); track innslag.sak.id) {
        @if (innslag.avstemninger.length > 0 || visAlleSaker()) {
          <div class="sak-kontainer">
            <a ajsRouterLink="innhold.moete.sak" [ajsRouterLinkParams]="{id: innslag.sak.moete.id, sakId:innslag.sak.id}" class="gå-til-sak-lenke">
              <h2 class="sak">
                <span class="nummer">{{ innslag.sak.nummer }}</span>
                <span>{{ innslag.sak.tittel }}</span>
              </h2>
            </a>

            @if (innslag.avstemninger.length > 0) {
              <sak-liste-avstemninger [sakId]="innslag.sak.id"
                                      [moeteId]="moeteId()"
                                      [moeteLaastForRedigering]="moete().laastForRedigering"
                                      [avstemningsstatus]="avstemningsstatus()"/>
            } @else {
              <div class="ingen-avstemninger">
                {{ 'Ingen avstemninger registrert på saken'|translate }}
              </div>
            }
          </div>
        }
      }
    </verdi>
  </tittel-verdi>

} @else {
  <tips>
    {{ 'Møte inneholder ingen saker med avstemninger. Avstemninger legges til under de enkelte sakene.'|translate }}
  </tips>
}
